import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategorieslist, getAllSize } from "../../../../../redux/size/action";
import { getAllBrands } from "../../../../../redux/brand/action";
import { getAllOccassion } from "../../../../../redux/occassion/action";
import { getSubcategory } from "../../../../../redux/subcategory/action";
import { getAllColor } from "../../../../../redux/color/action";

const ALL_PARAMS = { page: 1, per_page: "1000", search_key: "", status: "" };

const labelOf = (item) => item?.title ?? item?.name ?? "";

const buildLookup = (list) => {
  const map = new Map();
  (list || []).forEach((item) => {
    if (item?.id != null) map.set(String(item.id), labelOf(item));
  });
  return map;
};

export function useProductFilterOptions(categoryIds) {
  const dispatch = useDispatch();

  const categories = useSelector((s) => s.reusableSlice.catagoriesList);
  const brands = useSelector((s) => s.reusableSlice.brandList);
  const occasions = useSelector((s) => s.reusableSlice.occassionList);
  const subcategories = useSelector((s) => s.reusableSlice.subcategoriesList);
  const sizes = useSelector((s) => s.reusableSlice.sizeListData);
  const colors = useSelector((s) => s.reusableSlice.colorListData);

  useEffect(() => {
    dispatch(getAllCategorieslist(ALL_PARAMS));
    dispatch(getAllBrands(ALL_PARAMS));
    dispatch(getAllOccassion(ALL_PARAMS));
    dispatch(getAllSize(ALL_PARAMS));
    dispatch(getAllColor(ALL_PARAMS));
  }, [dispatch]);

  useEffect(() => {
    if (categoryIds) {
      dispatch(getSubcategory({ ...ALL_PARAMS, category_ids: categoryIds }));
    }
  }, [dispatch, categoryIds]);

  const categoryOptions = useMemo(
    () =>
      (Array.isArray(categories) ? categories : []).map((c) => ({
        value: c?.id,
        label: c?.title,
      })),
    [categories]
  );

  const brandOptions = useMemo(
    () => (brands || []).map((b) => ({ value: b?.id, label: b?.name })),
    [brands]
  );

  const occasionOptions = useMemo(
    () => (occasions || []).map((o) => ({ value: o?.id, label: o?.name })),
    [occasions]
  );

  const subcategoryOptions = useMemo(
    () => (subcategories || []).map((s) => ({ value: s?.id, label: s?.title })),
    [subcategories]
  );

  const sizeById = useMemo(() => buildLookup(sizes), [sizes]);
  const colorById = useMemo(() => buildLookup(colors), [colors]);

  return {
    categoryOptions,
    brandOptions,
    occasionOptions,
    subcategoryOptions,
    sizeById,
    colorById,
  };
}
